document.addEventListener("DOMContentLoaded", function () {
    const preloader = document.getElementById("preloader");
    const content = document.getElementById("content");
    const slideTarget = document.querySelector(".slide-target"); // For slide-in-down
    const slideTargetRight = document.querySelector(".slide-target-right"); // For slide-in-right
  const elements = document.querySelectorAll('.slide-in-right');
  
 
    // Simulate content readiness after all resources load
    window.addEventListener("load", function () {
        // Add a gradual fade-out class
        preloader.classList.add("fade-out");

        // Wait for the fade-out animation to finish
        setTimeout(function () {
            content.style.display = "block"; // Show main content
 elements.forEach(element => {
    element.classList.add('show');
  });
            // Trigger animations for slide targets
            slideTarget.classList.add("slide-in-down-hero"); // Slide from the top
            slideTargetRight.classList.add("slide-in-right-hero"); // Slide from the right
        }, 200); // Match the total duration of the fade-out animation
    });
});




document.addEventListener("DOMContentLoaded", function() {
  const slideInElements = document.querySelectorAll('.slide-in-from-left');

  const observerOptions = {
    root: null,
    threshold: 0.2 // Trigger when 10% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target); // Stop observing once animation is triggered
      }
    });
  }, observerOptions);

  slideInElements.forEach((element) => {
    observer.observe(element);
  });
});



document.addEventListener("DOMContentLoaded", function() {
  const slideInElements = document.querySelectorAll('.slide-in-from-right');

  const observerOptions = {
    root: null,
    threshold: 0.2 // Trigger when 10% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target); // Stop observing once animation is triggered
      }
    });
  }, observerOptions);

  slideInElements.forEach((element) => {
    observer.observe(element);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('.fade-in-down-stagger, .impact-number'); // Combined elements
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const target = entry.target;

        // Handle fade-in-down-stagger animation
        if (target.classList.contains('fade-in-down-stagger')) {
          setTimeout(() => {
            target.classList.add('show');
          }, index * 400); // staggered effect
        }

        // Handle count-up animation
        if (target.classList.contains('impact-number')) {
          const targetNumber = parseInt(target.getAttribute('data-count'), 10);
          const duration = 500; // 2 seconds duration
          let start = 0;
          const increment = targetNumber / (duration / 16.6667); // Smooth increment based on 60fps

          function countUp() {
            start += increment;
            if (start >= targetNumber) {
              target.textContent = targetNumber.toLocaleString();
            } else {
              target.textContent = Math.ceil(start).toLocaleString();
              requestAnimationFrame(countUp);
            }
          }
          requestAnimationFrame(countUp); // Start counting
        }

        observer.unobserve(target); // Stop observing the current element
      }
    });
  }, observerOptions);

  // Start observing combined elements
  elements.forEach(element => observer.observe(element));
});



document.addEventListener("DOMContentLoaded", function() {


    const fadeElements = document.querySelectorAll('.fade-in-down-scroll');

    const observerOptions = {
        root: null, // default is viewport
        threshold: 0.3 // Trigger when 10% of the element is visible
    };

    const fadeInOnScroll = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                observer.unobserve(entry.target); // Stop observing once the animation is triggered
            }
        });
    };

    const observer = new IntersectionObserver(fadeInOnScroll, observerOptions);

    fadeElements.forEach(element => {
        observer.observe(element);
    });
});


document.addEventListener("DOMContentLoaded", function() {
  const observerOptions = {
    threshold: 0.1 // Adjust this value to trigger the effect sooner or later
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-rotate');
        observer.unobserve(entry.target); // Stop observing after the effect is applied
      }
    });
  }, observerOptions);

  const targetElement = document.querySelector('.dots-bg-2');
  if (targetElement) {
    observer.observe(targetElement);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const observerOptions = {
    threshold: 0.3 // Adjust this value to trigger the effect sooner or later
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-rotate');
        observer.unobserve(entry.target); // Stop observing after the effect is applied
      }
    });
  }, observerOptions);

  const targetElement = document.querySelector('.dots-bg-3');
  if (targetElement) {
    observer.observe(targetElement);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const observerOptions = {
    threshold: 0.3 // Adjust this value to trigger the effect sooner or later
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-rotate');
        observer.unobserve(entry.target); // Stop observing after the effect is applied
      }
    });
  }, observerOptions);

  const targetElement = document.querySelector('.dots-bg-left');
  if (targetElement) {
    observer.observe(targetElement);
  }
});

window.addEventListener('load', function() {
  const promiseBlocks = document.querySelectorAll('.promise-block');
  
  // Animate the first two elements on page load
  promiseBlocks[0].classList.add('visible', 'stagger-1');
  promiseBlocks[1].classList.add('visible', 'stagger-2');
  
  // Use Intersection Observer for the other two
  const observerOptions = {
    threshold: 0.1 // Trigger when 50% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // Stop observing once the animation is triggered
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  observer.observe(promiseBlocks[2]);
  observer.observe(promiseBlocks[3]);
});


document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('.slide-in-up');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });  // Trigger when 10% of the element is visible

  elements.forEach(element => {
    observer.observe(element);
  });
});


document.addEventListener("DOMContentLoaded", function () {


  // For multiple '.wipe-reveal' elements
  const wipeElements = document.querySelectorAll('.wipe-reveal');
  wipeElements.forEach(element => {
    element.classList.add('show');
  });

  // For multiple '.fade-in' elements
  const fadeElements = document.querySelectorAll('.fade-in');
  fadeElements.forEach(element => {
    element.classList.add('show');
  });
});


function adjustPadding() {
  const sourceElement = document.querySelector('.hero-block');
  const targetElement = document.querySelector('.hero-bg .wp-block-column:nth-child(1)');
    const targetElement2 = document.querySelector('.hero-bg .wp-block-column:nth-child(2)');

  if (sourceElement && targetElement) {
    // Get the height of the source element
    const sourceHeight = sourceElement.offsetHeight;

    // Set the top padding of the target element to the height of the source element


    targetElement.style.paddingTop = `${sourceHeight + 50}px`;


        targetElement2.style.paddingTop = `${sourceHeight +120}px`;
      

  }
}

// Adjust padding on page load
document.addEventListener("DOMContentLoaded", adjustPadding);

// Adjust padding on window resize
window.addEventListener("resize", adjustPadding);


document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('.slide-in-down');
  
  elements.forEach(element => {
    element.classList.add('show');
  });
});

document.addEventListener("DOMContentLoaded", function () {

});

document.addEventListener("DOMContentLoaded", function() {
  const textElements = document.querySelectorAll('.text-fade-in-down');

  const observerOptions = {
    root: null,
    threshold: 0.1,  // Trigger when 10% of the element is visible
  };

  const observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scrolled');
        observer.unobserve(entry.target); // Remove observer after the animation triggers
      }
    });
  }, observerOptions);

  textElements.forEach(textElement => {
    observer.observe(textElement);
  });
});
        (function($) {

// Ensure jQuery is available
    $(document.body).on('click', '.cite-copy', function(e) {
        e.preventDefault();

         var content = $(this).parent().parent().find('.cite-popup').text();
    // Create a temporary textarea element to hold the text to copy
    var tempElement = $('<textarea>');
    $('body').append(tempElement);

    // Set the text of the textarea to the content
    tempElement.val(content).select();

    // Copy the content to the clipboard
    document.execCommand('copy');

    // Remove the temporary element
    tempElement.remove();

     // Show the popup
    var popup = $('#copy-popup');
    popup.fadeIn(200);  // Fade in the popup over 200ms

    // Hide the popup after 2 seconds (2000ms)
    setTimeout(function() {
        popup.fadeOut(200);  // Fade out the popup over 200ms
    }, 2000);
    });

    $(document.body).on('click', '.link-cite', function(e) {

      e.preventDefault();
$(this).addClass('active');

$(this).find('.publication-cite-popup').show();
});

   $(document.body).on('click', '.link-share', function(e) {
          e.preventDefault();

$(this).addClass('active');

$(this).find('.publication-share-popup').show();
});

$(document).on('click', function (event) {
    // Check if the clicked target is not inside .publication-cite-popup and it's not the .link-cite
    if (!$(event.target).closest('.publication-cite-popup, .link-cite').length) {
        // Hide .publication-cite-popup
        $('.publication-cite-popup').hide();

        // Remove the 'active' class from .link-cite
        $('.link-cite').removeClass('active');
    }
});

$(document).on('click', function (event) {
    // Check if the clicked target is not inside .publication-cite-popup and it's not the .link-cite
    if (!$(event.target).closest('.publication-share-popup, .link-share').length) {
        // Hide .publication-cite-popup
        $('.publication-share-popup').hide();

        // Remove the 'active' class from .link-cite
        $('.link-share').removeClass('active');
    }
});


    $(document.body).on('click', '.bar-expand', function(e) {

      $('.causes-tree-chart').toggleClass('graph-shrink');
      $('.causes-bar-chart').toggleClass('graph-grow');
      $('.chart-tabs').toggleClass('chart-no-gap');

    });


    $(document.body).on('click', '.tree-expand', function(e) {

      $('.causes-bar-chart').toggleClass('graph-shrink');
      $('.causes-tree-chart').toggleClass('graph-grow');
      $('.chart-tabs').toggleClass('chart-no-gap');


    });
   $(document.body).on('mouseenter', '#search-icon', function(e) {

    $('#search-form').addClass('show-search');

});




    $(document.body).on('click', '.graph-col-expand', function(e) {

     

     $(this).parent().parent().parent().toggleClass('graph-col-expanded');
          $(this).parent().parent().parent().siblings().toggleClass('graph-col-shrink');


    })




        })(jQuery);



document.querySelectorAll('.content-white')[1].style.paddingTop = '4%'; // Adjust the value as needed
